import WarranteeListPage from "./warranteeList.container";

export default WarranteeListPage;
